module.exports = __webpack_public_path__ + "img/logo-dark.70c19b50.png";